import * as React from 'react';

const CheckOutChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 6h2v12h-2v2h4V4h-4v2zM4 12l5 5 1.4-1.4L7.8 13H16v-2H7.8l2.6-2.6L9 7z"
        />
    </svg>
);

CheckOutChunkySvg.displayName = 'CheckOutChunkySvg';
export default CheckOutChunkySvg;
